import { AuthTokenResponseSchema } from '@repo/schema/user'
import { UpFetch } from '@repo/upfetch'
import { z } from '@repo/schema'

import { createProcedure } from '../../lib/procedure'

export const createAuthRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)

  return {
    impersonate: {
      start: p
        .path(z.object({ userId: z.number() }), params => ['auth', 'impersonate', params.userId])
        .mutation(({ path, upFetch }) =>
          upFetch(path, {
            method: 'POST',
            schema: AuthTokenResponseSchema,
          }),
        ),
      stop: p.path('auth', 'impersonate', 'stop').mutation(({ path, upFetch }) =>
        upFetch(path, {
          method: 'POST',
          schema: AuthTokenResponseSchema,
        }),
      ),
    },
  }
}
